export default __webpack_public_path__ + "static/media/categories3.b91f6e40.png";